import React from 'react'
import PlaylistHead from './PlaylistHead'
import PlaylistBody from './PlaylisyBody'

function Playlist() {
    return (
        <div className="playlist">
            <PlaylistHead />
            <PlaylistBody />
        </div>
    )
}

export default Playlist
